module.exports = __webpack_public_path__ + "img/partly_cloudy_night.7003d5d5.svg";